var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeaksFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "border shadow-md",
    viewBox: "0 0 1422.08 1066.56",
    style: {
      width: "1422.08px",
      height: "1066.56px"
    },
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    id: "bg",
    x: 0,
    y: 0,
    width: 1422.08,
    height: 1066.56,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 -152.3657142857143 L 0 -152.37 L 246.00 -2.37 L 355.52 -152.37 L 355.52 -152.37 L 590.52 -63.37 L 711.04 -152.37 L 711.04 -152.37 L 829.55 -76.18 L 1066.56 -152.37 L 1066.56 -152.37 L 1185.07 -21.37 L 1422.08 -152.37 L 1422.08 -152.37 L 1540.59 -51.37 L 1777.6 -152.37  V 1066.56 H 0 V -152.37 Z",
    fill: "#00527C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 0.00 L 225.00 99.00 L 355.52 0.00 L 355.52 0.00 L 491.52 88.00 L 711.04 0.00 L 711.04 0.00 L 888.04 76.18 L 1066.56 0.00 L 1066.56 0.00 L 1185.07 82.00 L 1422.08 0.00 L 1422.08 0.00 L 1557.08 76.18 L 1777.6 0.00  V 1066.56 H 0 V 0.00 Z",
    fill: "#055f89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 152.3657142857143 L 0 152.37 L 118.51 228.55 L 355.52 152.37 L 355.52 152.37 L 534.52 286.37 L 711.04 152.37 L 711.04 152.37 L 886.04 228.55 L 1066.56 152.37 L 1066.56 152.37 L 1248.56 228.55 L 1422.08 152.37 L 1422.08 152.37 L 1574.08 228.55 L 1777.6 152.37  V 1066.56 H 0 V 152.37 Z",
    fill: "#0a6c96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 304.7314285714286 L 0 304.73 L 118.51 380.91 L 355.52 304.73 L 355.52 304.73 L 533.52 391.73 L 711.04 304.73 L 711.04 304.73 L 967.04 380.91 L 1066.56 304.73 L 1066.56 304.73 L 1321.56 392.73 L 1422.08 304.73 L 1422.08 304.73 L 1592.08 425.73 L 1777.6 304.73  V 1066.56 H 0 V 304.73 Z",
    fill: "#0f79a3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 457.0971428571429 L 0 457.10 L 118.51 557.10 L 355.52 457.10 L 355.52 457.10 L 474.03 533.28 L 711.04 457.10 L 711.04 457.10 L 829.55 533.28 L 1066.56 457.10 L 1066.56 457.10 L 1185.07 533.28 L 1422.08 457.10 L 1422.08 457.10 L 1594.08 533.28 L 1777.6 457.10  V 1066.56 H 0 V 457.10 Z",
    fill: "#1486b0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 609.4628571428572 L 0 609.46 L 176.00 685.65 L 355.52 609.46 L 355.52 609.46 L 594.52 686.46 L 711.04 609.46 L 711.04 609.46 L 874.04 711.46 L 1066.56 609.46 L 1066.56 609.46 L 1291.56 711.46 L 1422.08 609.46 L 1422.08 609.46 L 1591.08 745.46 L 1777.6 609.46  V 1066.56 H 0 V 609.46 Z",
    fill: "#1993bd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 761.8285714285714 L 0 761.83 L 128.00 838.01 L 355.52 761.83 L 355.52 761.83 L 579.52 838.01 L 711.04 761.83 L 711.04 761.83 L 829.55 838.01 L 1066.56 761.83 L 1066.56 761.83 L 1262.56 838.01 L 1422.08 761.83 L 1422.08 761.83 L 1540.59 854.83 L 1777.6 761.83  V 1066.56 H 0 V 761.83 Z",
    fill: "#1ea0ca"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 914.1942857142858 L 0 914.19 L 242.00 990.38 L 355.52 914.19 L 355.52 914.19 L 619.52 990.38 L 711.04 914.19 L 711.04 914.19 L 829.55 990.38 L 1066.56 914.19 L 1066.56 914.19 L 1304.56 990.38 L 1422.08 914.19 L 1422.08 914.19 L 1540.59 991.19 L 1777.6 914.19  V 1066.56 H 0 V 914.19 Z",
    fill: "#23add7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaksFull);
export default __webpack_public_path__ + "static/media/peaks_full.a1f6c082454e200e3d23c69d18783716.svg";
export { ForwardRef as ReactComponent };